document.addEventListener("page:loaded", () => {

  if (typeof subscribe === "undefined") return;
  if (typeof PUB_SUB_EVENTS === "undefined") return;

  subscribe(PUB_SUB_EVENTS.variantChange, () => {

    const media = document.querySelectorAll(
      ".product__media img, .product__media-item img, .product__media-list img"
    );

    media.forEach((img) => {

      img.animate(
        [
          {
            opacity: .25,
            transform: "scale(1.04)"
          },
          {
            opacity: 1,
            transform: "scale(1)"
          }
        ],
        {
          duration: 350,
          easing: "cubic-bezier(.22,1,.36,1)",
          fill: "both"
        }
      );

    });

  });

});